import { useQuery } from "@tanstack/react-query";
import { EventTravelBlockService } from "Bands/services/EventTravelBlockService";
import { IEventSuggestedLocation } from "Bands/types";

export const useSuggestedLocation = (id: string | null) => {
  return useQuery({
    queryKey: ["suggestedLocation", id],
    queryFn: async () => {
      if (!id) return null;
      const response = await EventTravelBlockService.getSuggestedLocation(id);

      // Extract the suggested location data from the JSONAPI response
      const locationData =
        response.eventSuggestedLocation?.[`/api/event_suggested_locations/${id}`];
      return locationData?.attributes as unknown as IEventSuggestedLocation;
    },
    enabled: !!id, // Only run query if id is provided
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
};
